import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA7mRedZDwl-EdonSYYjbEiTo_BLjjcaNw",
  authDomain: "isabellebm-63f4f.firebaseapp.com",
  projectId: "isabellebm-63f4f",
  storageBucket: "isabellebm-63f4f.firebasestorage.app",
  messagingSenderId: "550534555915",
  appId: "1:550534555915:web:bf1d3d353e0cb4a91d5a0e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app;
